import React from "react";
import { StyledButton } from "@app/common/components/Button.styles";

export const InvestButton: React.FC = ({ children }) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    let baseUrl = "";

    if (GLOBAL_CONFIG.baseUrl !== "") {
      baseUrl = GLOBAL_CONFIG.baseUrl.charAt(0) !== "/" ? `/${GLOBAL_CONFIG.baseUrl}` : GLOBAL_CONFIG.baseUrl;
    }

    window.location.href = `${window.location.origin}${baseUrl}/apply`;
  };

  return (
    <StyledButton variant="primary" onClick={handleClick}>
      {children}
    </StyledButton>
  );
};
